(function () {
  function starGlyphPainted(star) {
    if (!star) return false;
    try {
      var before = window.getComputedStyle(star, '::before');
      var content = before && before.content ? before.content.replace(/['"]/g, '') : '';
      if (content && content !== 'none' && content !== 'normal') {
        var rect = star.getBoundingClientRect();
        if (rect.width > 6 && rect.height > 6) return true;
      }
    } catch (e) {
      /* ignore */
    }
    return false;
  }

  function badgeHasLiveRating(badge) {
    if (!badge) return false;

    var stars = badge.querySelectorAll('.jdgm-star');
    if (!stars.length) return false;

    var painted = 0;
    for (var i = 0; i < stars.length; i++) {
      if (starGlyphPainted(stars[i])) painted += 1;
    }
    // Require real Judge.me icon glyphs — empty spans with only "31 reviews" text are not enough
    return painted >= 3;
  }

  function syncPreviews() {
    document.querySelectorAll('[data-sunnier-judgeme-preview]').forEach(function (el) {
      var badge = el.querySelector('.jdgm-preview-badge');
      el.classList.toggle('has-judgeme-live', badgeHasLiveRating(badge));
    });
  }

  function scrollToReviews(event) {
    var link = event.target.closest('a.sunnier-judgeme-preview, a[href="#judgeme_product_reviews"]');
    if (!link) return;

    var target =
      document.getElementById('judgeme_product_reviews') ||
      document.querySelector('.jdgm-rev-widg, .jdgm-review-widget');
    if (!target) return;

    event.preventDefault();
    var headerOffset = 96;
    var sticky = document.querySelector('sticky-header, .shopify-section-header-sticky, .header-wrapper');
    if (sticky) {
      headerOffset = Math.max(headerOffset, sticky.getBoundingClientRect().height + 16);
    }

    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
    window.scrollTo({ top: top, behavior: 'smooth' });
    history.replaceState(null, '', '#judgeme_product_reviews');
  }

  document.addEventListener('click', scrollToReviews, true);

  function tick(attempt) {
    syncPreviews();
    if (attempt < 20) setTimeout(function () { tick(attempt + 1); }, 400);
    else if (attempt < 30) setTimeout(function () { tick(attempt + 1); }, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { tick(0); });
  } else {
    tick(0);
  }
  window.addEventListener('load', syncPreviews);
})();
